export default {
  // TODO: Translate (PWA)
  staff: {
    contactAdministrator: 'Not Implemented.',
    defaultContinue: 'Not Implemented.',
    memberPin: 'Not Implemented.',
    errorInactive: 'Not Implemented.',
    errorInvalidPasscode: 'Not Implemented.',
    errorInvalidPin: 'Not Implemented.',
    hiName: 'Not Implemented.',
    passcode: 'Not Implemented.',
    passcodePrompt: 'Not Implemented.',
    pin: 'Not Implemented.',
    surveyContinue: 'Not Implemented.',
    surveysDisabled: 'Not Implemented.',
    surveySelect: 'Not Implemented.',
    surveySelected: 'Not Implemented.',
    startSurvey: 'Not Implemented.'
  }
};